function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function showFormError(form, message) {
  var container = form.closest('product-form') || form;
  var wrapper = container.querySelector('.product-form__error-message-wrapper');
  var msgEl = container.querySelector('.product-form__error-message');
  if (msgEl) msgEl.textContent = message;
  if (wrapper) wrapper.removeAttribute('hidden');
}
function clearFormError(form) {
  var container = form.closest('product-form') || form;
  var wrapper = container.querySelector('.product-form__error-message-wrapper');
  if (wrapper) wrapper.setAttribute('hidden', '');
}
export function updateCartCountTopping() {
  return _updateCartCountTopping.apply(this, arguments);
}
function _updateCartCountTopping() {
  _updateCartCountTopping = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var response, cartHTML, parser, newDocument, newCartBubble, currentCartBubble, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return fetch("".concat(window.Shopify.routes.root, "?section_id=cart-icon-bubble"));
        case 1:
          response = _context.v;
          _context.n = 2;
          return response.text();
        case 2:
          cartHTML = _context.v;
          parser = new DOMParser();
          newDocument = parser.parseFromString(cartHTML, 'text/html');
          newCartBubble = newDocument.querySelector('#shopify-section-cart-icon-bubble');
          currentCartBubble = document.querySelector('#cart-icon-bubble');
          if (newCartBubble && currentCartBubble) {
            currentCartBubble.innerHTML = newCartBubble.innerHTML;
          }
          _context.n = 4;
          break;
        case 3:
          _context.p = 3;
          _t = _context.v;
          console.error("Error al actualizar el contador del carrito:", _t);
        case 4:
          return _context.a(2);
      }
    }, _callee, null, [[0, 3]]);
  }));
  return _updateCartCountTopping.apply(this, arguments);
}
export function updateCartDrawerTopping() {
  return _updateCartDrawerTopping.apply(this, arguments);
}
function _updateCartDrawerTopping() {
  _updateCartDrawerTopping = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var response, cartHTML, parser, newDocument, newCartDrawer, currentCartDrawer, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          _context2.p = 0;
          _context2.n = 1;
          return fetch("".concat(window.Shopify.routes.root, "?section_id=cart-drawer"));
        case 1:
          response = _context2.v;
          _context2.n = 2;
          return response.text();
        case 2:
          cartHTML = _context2.v;
          parser = new DOMParser();
          newDocument = parser.parseFromString(cartHTML, 'text/html');
          newCartDrawer = newDocument.querySelector('cart-drawer');
          currentCartDrawer = document.querySelector('cart-drawer');
          if (newCartDrawer && currentCartDrawer) {
            currentCartDrawer.replaceWith(newCartDrawer);
          }
          _context2.n = 4;
          break;
        case 3:
          _context2.p = 3;
          _t2 = _context2.v;
          console.error("Error al actualizar el carrito:", _t2);
        case 4:
          return _context2.a(2);
      }
    }, _callee2, null, [[0, 3]]);
  }));
  return _updateCartDrawerTopping.apply(this, arguments);
}
export function openCartTopping() {
  return _openCartTopping.apply(this, arguments);
}
function _openCartTopping() {
  _openCartTopping = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
    var cartIcon;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          cartIcon = document.querySelector('.header__icon.header__icon--cart');
          if (cartIcon) {
            cartIcon.click();
            document.body.classList.add('overflow-hidden');
          }
        case 1:
          return _context3.a(2);
      }
    }, _callee3);
  }));
  return _openCartTopping.apply(this, arguments);
}
export function addProductToCartTopping() {
  return _addProductToCartTopping.apply(this, arguments);
}
function _addProductToCartTopping() {
  _addProductToCartTopping = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
    var addToCartBtns;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          addToCartBtns = document.querySelectorAll('.product-form__submit[type="submit"]');
          addToCartBtns.forEach(function (btn) {
            btn.addEventListener('click', /*#__PURE__*/function () {
              var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
                var form, formData, data, item, response, message, err, _t3, _t4;
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.p = _context4.n) {
                    case 0:
                      e.preventDefault();
                      form = this.closest('form');
                      clearFormError(form);
                      formData = new FormData(form);
                      data = Object.fromEntries(formData.entries());
                      console.log('data', data);
                      item = {
                        "items": [{
                          id: data.id,
                          quantity: data.quantity,
                          properties: {
                            'Cover': data['properties[Cover]'],
                            'Filling': data['properties[Filling]'],
                            'Additional': data['properties[Additional]'],
                            'Topping': data['properties[Topping]'],
                            'Comment': data['properties[Comment]'] || undefined,
                            '_AdditionalProductId': data['additionalProductId'],
                            '_AdditionalToppingId': data['additionalToppingId']
                          }
                        }]
                      };
                      console.log('item', item);
                      if (data.additionalProductId && data.additionalProductId !== '') {
                        item.items.push({
                          id: data.additionalProductId,
                          quantity: data.quantity,
                          properties: {
                            "_additional": "true",
                            "_parent_id": data.id,
                            "_product_id": data.additionalProductId
                          }
                        });
                      }
                      if (data.additionalToppingId && data.additionalToppingId !== '') {
                        item.items.push({
                          id: data.additionalToppingId,
                          quantity: data.quantity,
                          properties: {
                            "_additional": "true",
                            "_parent_id": data.id,
                            "_topping_id": data.additionalToppingId
                          }
                        });
                      }
                      _context4.p = 1;
                      _context4.n = 2;
                      return fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(item)
                      });
                    case 2:
                      response = _context4.v;
                      if (response.ok) {
                        _context4.n = 7;
                        break;
                      }
                      // Shopify devuelve 422 con { description, message } cuando excede el stock.
                      message = 'No se pudo agregar el producto al carrito.';
                      _context4.p = 3;
                      _context4.n = 4;
                      return response.json();
                    case 4:
                      err = _context4.v;
                      message = err.description || err.message || message;
                      _context4.n = 6;
                      break;
                    case 5:
                      _context4.p = 5;
                      _t3 = _context4.v;
                    case 6:
                      showFormError(form, message);
                      return _context4.a(2);
                    case 7:
                      _context4.n = 8;
                      return updateCartCountTopping();
                    case 8:
                      _context4.n = 9;
                      return updateCartDrawerTopping();
                    case 9:
                      _context4.n = 10;
                      return openCartTopping();
                    case 10:
                      _context4.n = 12;
                      break;
                    case 11:
                      _context4.p = 11;
                      _t4 = _context4.v;
                      console.error('Error:', _t4);
                      showFormError(form, 'Ocurrió un error de red. Intenta de nuevo.');
                    case 12:
                      return _context4.a(2);
                  }
                }, _callee4, this, [[3, 5], [1, 11]]);
              }));
              return function (_x) {
                return _ref.apply(this, arguments);
              };
            }());
          });
        case 1:
          return _context5.a(2);
      }
    }, _callee5);
  }));
  return _addProductToCartTopping.apply(this, arguments);
}